import React from 'react'
import PropTypes from 'prop-types'

import classNames from 'classnames'

import { Container } from '@scentregroup/ui'
import containerStyles from '../../../components/container.scss'
import productImpressions from '../../../helpers/analytics-utils/product-impressions'
import Pagination from './pagination'
import ProductCard from './product-card'

import style from './products-gallery.scss'

const ProductsGallery = ({ products = [], className, ...pagination }) => {
  const list = 'Product Listing Page'
  productImpressions(products, list)
  return (
    <div className={classNames(style.galleryView, className)}>
      <Container
        className={classNames(containerStyles.container, style.gallery)}
        type="large"
      >
        {products.map((product, index) => (
          <ProductCard
            key={index}
            className={style.cards}
            src={product.images[0]}
            retailer={product.retailer.name}
            productName={product.name}
            price={product.price}
            salePrice={product.isDiscounted ? product.salePrice : undefined}
            link={`/products/${product.retailer.retailerCode}/${
              product.nameSlug
            }/${product.objectId}`}
            id={product.objectId}
            primaryCategory={product.primaryCategory}
            brand={product.brand}
            list={list}
            position={index + 1}
            retailerCode={product.retailer.retailerCode}
          />
        ))}
      </Container>
      <Pagination {...pagination} className={style.pagination} />
    </div>
  )
}

ProductsGallery.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
}

export default ProductsGallery
